/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { env } from '$env/dynamic/public';

export function initDatadog() {
    if (typeof window === 'undefined') return;
    if (env.PUBLIC_NODE_ENV !== 'dev') {
    // Initialize RUM
    datadogRum.init({
        applicationId: '820cef69-793e-4cf5-84de-c497f43b33b3',
        clientToken: 'pubf4f6dc6d82bbec425eba4748a1a1abb3',
        site: 'datadoghq.com',
        service: 'conversational-ui-rum',
        env: `${env.PUBLIC_NODE_ENV}`,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 0,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
    });

    datadogRum.startSessionReplayRecording();

    // Initialize Logs
    datadogLogs.init({
        clientToken: 'pub26aad20f5d5e19948fa9cfe8af1c07dd',
        site: 'datadoghq.com',
        service: 'conversational-ui-logging',
        env: `${env.PUBLIC_NODE_ENV}`,
        forwardErrorsToLogs: true,
        sessionSampleRate: 100
    });
    }
}